import { render, staticRenderFns } from "./App.vue?vue&type=template&id=4916a46a&"
import script from "./App.vue?vue&type=script&lang=js&"
export * from "./App.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/srv/www/finda/current/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4916a46a')) {
      api.createRecord('4916a46a', component.options)
    } else {
      api.reload('4916a46a', component.options)
    }
    module.hot.accept("./App.vue?vue&type=template&id=4916a46a&", function () {
      api.rerender('4916a46a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "buysearchsell/vue/App.vue"
export default component.exports